var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { getPropsByKeyPath } from 'src/shared/helpers/objHelpers';
import styles from 'src/ui/views/dynamics/CaseGlobalViewPage/sections/History/HistoryList/HistoryItems/IncompleteItem/incompleteItem.module.scss';
export var IncompleteRefusalElements = function (props) {
    var i18n = props.i18n, refusedElements = props.refusedElements;
    var hasRefusalElements = refusedElements.length > 0;
    if (!hasRefusalElements) {
        return null;
    }
    var refusedLabel = getPropsByKeyPath(i18n, 'modules.timeline.incompleteCase.refusedDocumentsLabel');
    return (_jsxs(_Fragment, { children: [_jsx("span", __assign({ className: styles.incompleteDocumentListLabel }, { children: refusedLabel })), _jsx("ul", __assign({ className: styles.incompleteDocumentList }, { children: refusedElements.map(function (elem) {
                    var hasRefusalReasons = elem.refusalReasons && elem.refusalReasons.length > 0;
                    var label = hasRefusalReasons ? "".concat(elem.label, " : ") : elem.label;
                    return (_jsxs("li", __assign({ className: styles.incompleteDocumentItem }, { children: [_jsx("span", __assign({ className: styles.incompleteDocumentItemLabel }, { children: label })), hasRefusalReasons && (_jsx("ul", __assign({ className: styles.incompleteDocumentReasonsList }, { children: elem.refusalReasons.map(function (reasonEl) { return (_jsx("li", { children: reasonEl.label }, reasonEl.code)); }) })))] }), elem.label));
                }) }))] }));
};
